<template>
    <list-group-item :action="clickAction" color="primary">
        <i class="fas fa-question"></i> <strong>{{ label }}</strong>
    </list-group-item>
</template>

<script type="text/javascript">
    import UIComponents from '@/components/UI/index.vue';

    export default {
        components: {
            ...UIComponents,
        },

        props: {
            pendingInqueries: {
                type: Number,
                required: true,
            },
        },

        emits: ['click'],

        computed: {
            label() {
                if (this.pendingInqueries == 1) {
                    return 'An inquiry is waiting for your response';
                }
                else {
                    return 'You have '+this.pendingInqueries+' pending inquiries';
                }
            }
        },

        methods: {
            clickAction() {
                this.$emit('click');
                this.$router.push('/owners/inquiries');
            },
        },
    }
</script>